import React from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { selectUserConfig, selectIsLoading } from '@selectors'

import ContactsList from '@components/contacts-list/contacts-list.component'

import {
  Button,
  DARK_GREEN,
  GREEN,
  IconInline,
  Paragraph,
  ResponsiveContainer
} from '@omnilert/components'

import {
  UPDATE_LOADING,
  ATTEMPT_SUBMIT_ALERT_WITH_LOCATION,
  SHOW_ACTION_SHEET
} from '@actions/types'

import {
  SAFEWALK_CONTACTS_DESCRIPTION,
  SAFEWALK_CONTACTS_DISCLAIMER,
  SAFEWALK_SMS_DESCRIPTION,
  BUTTON_SAFEWALK_ACTIVATE,
  BUTTON_SAFEWALK_CHECK_IN_TIMER_SET,
  BUTTON_SAFEWALK_CHECKIN_TIMER,
  BUTTON_SAFEWALK_ADD_CONTACTS
} from '@assets/i18n/strings'

import i18n from 'i18n-js'

import dayjs from 'dayjs'

import useStyles from './safewalk-on-campus.style'

const SafeWalkOnCampus = () => {
  const dispatch = useDispatch()

  const duration = useSelector(state => state.safewalk.formDuration)
  const userConfig = useSelector(selectUserConfig)
  const loading = useSelector(selectIsLoading)
  const isLoadingSecondary = loading.some(({ meta }) => meta === 'walk-activated')
  const contacts = userConfig?.emergency_contacts || []

  const durationIsSet = duration > 0
  const hasContacts = !!contacts.length

  const classes = useStyles({ duration })

  const hours = dayjs.duration(duration, 'ms').hours()
  const minutes = dayjs.duration(duration, 'ms').minutes()
  const hoursText = hours > 0 ? `${hours} hr` : ''
  const minutesText = minutes > 0 ? `${minutes} min` : ''
  const formatedDuration = `${hoursText} ${minutesText}`

  const onClickBegin = () => {
    dispatch({
      type: UPDATE_LOADING,
      payload: {
        loadingAction: 'set',
        meta: 'walk-activated'
      }
    })

    dispatch({
      type: ATTEMPT_SUBMIT_ALERT_WITH_LOCATION,
      payload: {
        nextState: 'walk-activated'
      }
    })
  }

  const onClickSetTimer = () => {
    dispatch({
      type: SHOW_ACTION_SHEET,
      payload: 'SAFEWALKWALK'
    })
  }

  const onClickAddContacts = () => dispatch({ type: SHOW_ACTION_SHEET, payload: 'CONTACTS' })

  return (
    <ResponsiveContainer className={classes.responsive}>
      <IconInline
        className={classes.icon}
        name='clock'
        size={200}
      />
      {!durationIsSet &&
        <Button
          className={classes.primaryButton}
          fullWidth
          onClick={onClickSetTimer}
          size='lg'
          title={i18n.t(BUTTON_SAFEWALK_CHECKIN_TIMER)}
          titleClassName={classes.primaryButtonTitle}
          variant='solid'
        />}
      {durationIsSet &&
        <>
          <button
            className={classes.setTimeButton}
            onClick={onClickSetTimer}
            tabIndex={0}
            type='button'
          >
            {i18n.t(BUTTON_SAFEWALK_CHECK_IN_TIMER_SET, { duration: formatedDuration })}
          </button>
          <Button
            backgroundColor={GREEN}
            className={classes.primaryButton}
            fullWidth
            hoverBackgroundColor={DARK_GREEN}
            isLoading={isLoadingSecondary}
            onClick={onClickBegin}
            size='lg'
            title={i18n.t(BUTTON_SAFEWALK_ACTIVATE)}
            titleClassName={classes.primaryButtonTitle}
            variant='solid'
          />
          <Paragraph
            className={classes.smsDescriptionText}
            color='var(--tips__text)'
            size='sm'
          >
            {i18n.t(SAFEWALK_SMS_DESCRIPTION)}
          </Paragraph>
        </>}
      <Paragraph
        className={classes.alertDescriptionText}
        color='var(--tips__text)'
        size='md'
      >
        {i18n.t(SAFEWALK_CONTACTS_DESCRIPTION)}
      </Paragraph>
      {hasContacts &&
        <ContactsList
          className={classes.contactList}
          contacts={contacts}
        />}
      <Button
        backgroundColor={GREEN}
        fullWidth
        hoverBackgroundColor={DARK_GREEN}
        onClick={onClickAddContacts}
        size='lg'
        title={i18n.t(BUTTON_SAFEWALK_ADD_CONTACTS)}
        titleClassName={classes.contactsButtonTitle}
        variant={hasContacts ? 'solid' : 'outlined'}
      />
      <Paragraph
        className={classes.contactsDisclaimerText}
        color='var(--resource__description__text)'
        size='sm'
      >
        {i18n.t(SAFEWALK_CONTACTS_DISCLAIMER)}
      </Paragraph>
    </ResponsiveContainer>
  )
}

export default SafeWalkOnCampus
